<ng-template #overlay>
    <div class="modalcontent" [ngClass]="(isMobile$ | async) ? 'mobile' : 'desktop'">
        <h4 [innerHTML]="'maintenanceOverlay.title' | translate"></h4>
        <p [innerHTML]="'maintenanceOverlay.text' | translate"></p>
        <div class="modal-actions">
            <a da-button class="button primary" (click)="closeMaintenanceOverlay()" themeType="Primary" [innerHTML]="'maintenanceOverlay.close' | translate"></a>
        </div>
    </div>
</ng-template>

